import { useTranslation } from "react-i18next";
import {
	ThemeColorVariable,
	ThemeSpaceVariable,
	Button,
	Flex,
	Text,
	ModalBody,
	ModalCloseButton,
	ModalHeader,
	Heading,
	Link,
	Icons,
} from "@caspeco/casper-ui-library";
import { getLocalStorage } from "helpers/local-storage-helper/local-storage-helper";
import { IAppGeneralFeatures } from "types/appFeatures";

interface ISignInModalBecomeBusinessCustomer {
	onGoBack: () => void;
}

export function SignInModalBecomeBusinessCustomer({ onGoBack }: ISignInModalBecomeBusinessCustomer) {
	const { t } = useTranslation();
	const b2bEmailAddress = getLocalStorage<IAppGeneralFeatures>("appFeatures")?.b2bEmailAddress;

	return (
		<>
			<ModalHeader p={ThemeSpaceVariable.Medium}>
				<Flex align="center" justify="space-between">
					<Button variant="ghost" onClick={onGoBack} leftIcon={Icons.Back}>
						{t("account_sign_in")}
					</Button>
					<ModalCloseButton />
				</Flex>
			</ModalHeader>
			<ModalBody
				px={ThemeSpaceVariable.XLarge}
				pb={ThemeSpaceVariable.XLarge}
				pt={ThemeSpaceVariable.Large}
				textAlign="center"
			>
				<Heading color={ThemeColorVariable.OnSurfaceHeader} as="h2">
					{t("account_become_business_customer")}
				</Heading>
				<Text my={ThemeSpaceVariable.Large}>{t("account_become_business_customer_description")}</Text>
				<Link color={ThemeColorVariable.OnSurface} href={`mailto:${b2bEmailAddress}`}>
					{b2bEmailAddress}
				</Link>
			</ModalBody>
		</>
	);
}
